import type { Review, ReviewMedia } from '../../model/review/review';

const VIDEO_MEDIA_EXTENSIONS = ['.mp4', '.mov', '.webm'];

const isVideoMediaUrl = (url: string): boolean => {
  const pathname = url.split('?').at(0)?.toLowerCase() ?? '';
  return VIDEO_MEDIA_EXTENSIONS.some((extension) => pathname.endsWith(extension));
};

/** Reviews written before media carry no list, so the type is read off the URL instead. */
export const toReviewMediaEntries = (review: Pick<Review, 'media' | 'pictureUrls'>): ReviewMedia[] =>
  review.media?.length
    ? review.media
    : review.pictureUrls.map((url) => ({ url, type: isVideoMediaUrl(url) ? 'video' : 'image' }));
